module.exports = __webpack_public_path__ + "img/SchlafDerGerechten.29d81e51.svg";